import React from 'react';
import { Drawer, Menu, Typography } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import { useAppNavMenu } from '../../hooks/useAppNavMenu';

const { Text } = Typography;

interface AppNavDrawerProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Mobile navigation drawer — shared between AppLayout and MinimalLayout
 * so the hamburger menu works on every authenticated screen.
 */
const AppNavDrawer: React.FC<AppNavDrawerProps> = ({ open, onClose }) => {
  const { isSuperAdmin } = useAuth();
  const { menuItems, openKeys, setOpenKeys, selectedKey } = useAppNavMenu();

  return (
    <Drawer
      placement="left"
      open={open}
      onClose={onClose}
      width={280}
      styles={{ body: { padding: 0 } }}
      title={
        <div className="flex items-center gap-2.5">
          <div
            className={`w-8 h-8 rounded-lg flex items-center justify-center ${
              isSuperAdmin ? 'bg-amber-500' : 'bg-primary-600'
            }`}
          >
            <Text className="text-white font-semibold text-sm">
              {isSuperAdmin ? 'A' : 'B'}
            </Text>
          </div>
          <Text className="font-semibold text-gray-900">
            {isSuperAdmin ? 'Admin Panel' : 'BRAI'}
          </Text>
        </div>
      }
    >
      <Menu
        mode="inline"
        selectedKeys={[selectedKey]}
        openKeys={openKeys}
        onOpenChange={(keys) => setOpenKeys(keys as string[])}
        items={menuItems}
        className="border-none py-2 h-full"
        style={{ background: 'transparent' }}
        onClick={onClose}
      />
    </Drawer>
  );
};

export default AppNavDrawer;
